import { createElement, forwardRef, type SVGProps } from 'react';
import { EScrollUpButtonType, ScrollUpButtonProps } from '../types';

import styles from './styles.css';

const filtersPathD =
  'M10 8a4.002 4.002 0 0 0 3.874-3H16V3h-2.126a4.002 4.002 0 0 0-7.748 0H0v2h6.126C6.57 6.725 8.136 8 10 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-.126 5H16v2H9.874a4.002 4.002 0 0 1-7.748 0H0v-2h2.126a4.002 4.002 0 0 1 7.748 0ZM8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z';

const chevronPathD = 'M8 3.44.293 11.145l1.414 1.415L8 6.268l6.293 6.293 1.414-1.415L8 3.44Z';

const svgCommon = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
} as const;

/** Обходим обёртку createIcon из design-tokens (рантайм/MF); raw svg запрещён в JSX правилом react/forbid-elements. */
function renderScrollUpGlyph(kind: 'filters' | 'up', extra?: SVGProps<SVGSVGElement>) {
  const pathD = kind === 'filters' ? filtersPathD : chevronPathD;

  /* eslint-disable react/forbid-elements -- см. JSDoc выше */
  return createElement(
    'svg',
    { ...svgCommon, className: styles['icon'], ...extra },
    createElement('path', {
      d: pathD,
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor',
    }),
  );
  /* eslint-enable react/forbid-elements */
}

export const ScrollUpButton = forwardRef<HTMLButtonElement, ScrollUpButtonProps>(
  ({ iconType, onClick, testId }, ref) => (
    <button ref={ref} className={styles['root']} onClick={onClick} data-testid={testId}>
      {iconType === EScrollUpButtonType.Filters ? renderScrollUpGlyph('filters') : renderScrollUpGlyph('up')}
    </button>
  ),
);

ScrollUpButton.displayName = 'ScrollUpButton';
